import { createContext, useContext } from 'react';
import type { UserErrorLogs } from '@/enteties/broadcast/model';

export const EventContext = createContext<
  { userLogsErrors: UserErrorLogs | null } | undefined
>(undefined);

export const useEventContext = () => {
  const context = useContext(EventContext);
  return context;
};
